module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C136"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C137"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction: The Mission of Display")])])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1___A_Vi#page_8"
    }
  }, [_vm._v("1. “A Vision of the Future”: The New Museum Idea and Display Reform, 1890–1915")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__The_D#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Drama of the Diorama, 1910–1935")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Displ#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Displays in Motion: Experimentation and Stagnation in Exhibition, 1925–1940")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Diver#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Diversifying Displays, Diverging Museums: Postwar Life Science Education, 1941–1956")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5___An_I#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. “An Investment in the Future of America”: Competing Pedagogies in Post-Sputnik Museums, 1957–1969")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__The_E#page_208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Exploratorium Effect: Redefining Relevance and Interactive Display, 1969–1980")])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7__From#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. From Diversity to Standardization: Edutainment and Engagement in Museums at the End of the Century, 1976–2005")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Notes#page_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Bibliogr#page_395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliographic Essay on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliogr#page_409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C138"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Index#page_449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f96aaf3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0